<div class="rte-toolbar" role="toolbar" aria-label="Formatação do texto">
  <!-- Histórico -->
  <div class="rte-toolbar__group">
    <button
      type="button"
      class="rte-btn"
      pTooltip="Desfazer (Ctrl+Z)"
      tooltipPosition="bottom"
      aria-label="Desfazer"
      (mousedown)="$event.preventDefault()"
      (click)="emit({ type: 'undo' })">
      <i class="pi pi-undo"></i>
    </button>
    <button
      type="button"
      class="rte-btn"
      pTooltip="Refazer (Ctrl+Y)"
      tooltipPosition="bottom"
      aria-label="Refazer"
      (mousedown)="$event.preventDefault()"
      (click)="emit({ type: 'redo' })">
      <i class="pi pi-undo rte-btn__mirror"></i>
    </button>
  </div>

  <span class="rte-toolbar__sep" aria-hidden="true"></span>

  <!-- Estilo do parágrafo e tamanho -->
  <div class="rte-toolbar__group">
    <button
      type="button"
      class="rte-btn rte-btn--select rte-btn--paragraph"
      pTooltip="Estilo do parágrafo"
      tooltipPosition="bottom"
      aria-haspopup="menu"
      (mousedown)="$event.preventDefault()"
      (click)="paragraphMenu.toggle($event)">
      <span class="rte-btn__text">{{ paragraphLabel() }}</span>
      <i class="pi pi-chevron-down rte-btn__caret"></i>
    </button>
    <p-menu #paragraphMenu [model]="paragraphItems" [popup]="true" appendTo="body" />

    <button
      type="button"
      class="rte-btn rte-btn--select rte-btn--size"
      pTooltip="Tamanho da fonte"
      tooltipPosition="bottom"
      aria-haspopup="menu"
      (mousedown)="$event.preventDefault()"
      (click)="sizeMenu.toggle($event)">
      <span class="rte-btn__text">{{ sizeLabel() }}</span>
      <i class="pi pi-chevron-down rte-btn__caret"></i>
    </button>
    <p-menu #sizeMenu [model]="sizeItems" [popup]="true" appendTo="body" />
  </div>

  <span class="rte-toolbar__sep" aria-hidden="true"></span>

  <!-- Estilo do texto -->
  <div class="rte-toolbar__group">
    <button
      type="button"
      class="rte-btn rte-btn--glyph rte-btn--bold"
      [class.rte-btn--active]="isActive('bold')"
      [attr.aria-pressed]="isActive('bold')"
      pTooltip="Negrito (Ctrl+B)"
      tooltipPosition="bottom"
      aria-label="Negrito"
      (mousedown)="$event.preventDefault()"
      (click)="toggle('bold')">
      B
    </button>
    <button
      type="button"
      class="rte-btn rte-btn--glyph rte-btn--italic"
      [class.rte-btn--active]="isActive('italic')"
      [attr.aria-pressed]="isActive('italic')"
      pTooltip="Itálico (Ctrl+I)"
      tooltipPosition="bottom"
      aria-label="Itálico"
      (mousedown)="$event.preventDefault()"
      (click)="toggle('italic')">
      I
    </button>
    <button
      type="button"
      class="rte-btn rte-btn--glyph rte-btn--underline"
      [class.rte-btn--active]="isActive('underline')"
      [attr.aria-pressed]="isActive('underline')"
      pTooltip="Sublinhado (Ctrl+U)"
      tooltipPosition="bottom"
      aria-label="Sublinhado"
      (mousedown)="$event.preventDefault()"
      (click)="toggle('underline')">
      U
    </button>
    <button
      type="button"
      class="rte-btn rte-btn--glyph rte-btn--strike"
      [class.rte-btn--active]="isActive('strike')"
      [attr.aria-pressed]="isActive('strike')"
      pTooltip="Tachado"
      tooltipPosition="bottom"
      aria-label="Tachado"
      (mousedown)="$event.preventDefault()"
      (click)="toggle('strike')">
      S
    </button>

    <!-- Cor do texto: "A" com a barra da cor atual, como nos editores de documento -->
    <button
      type="button"
      class="rte-btn rte-btn--color"
      pTooltip="Cor do texto"
      tooltipPosition="bottom"
      aria-label="Cor do texto"
      aria-haspopup="dialog"
      (mousedown)="$event.preventDefault()"
      (click)="colorPopover.toggle($event)">
      <span class="rte-btn__letter">A</span>
      <span class="rte-btn__swatch" [style.background]="currentColor()"></span>
    </button>
    <p-popover #colorPopover appendTo="body" styleClass="rte-popover">
      <ng-container
        [ngTemplateOutlet]="paletteTemplate"
        [ngTemplateOutletContext]="{ name: 'color', resetLabel: 'Cor automática' }" />
    </p-popover>

    <!-- Destaque (cor de fundo) -->
    <button
      type="button"
      class="rte-btn rte-btn--color"
      pTooltip="Cor de destaque"
      tooltipPosition="bottom"
      aria-label="Cor de destaque"
      aria-haspopup="dialog"
      (mousedown)="$event.preventDefault()"
      (click)="backgroundPopover.toggle($event)">
      <svg class="rte-btn__svg" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M15.2 3.6 20.4 8.8 11 18.2H5.8v-5.2l9.4-9.4Zm0 2.8-7.4 7.4v2.4h2.4l7.4-7.4-2.4-2.4Z" />
      </svg>
      <span class="rte-btn__swatch" [style.background]="currentBackground()"></span>
    </button>
    <p-popover #backgroundPopover appendTo="body" styleClass="rte-popover">
      <ng-container
        [ngTemplateOutlet]="paletteTemplate"
        [ngTemplateOutletContext]="{ name: 'background', resetLabel: 'Sem destaque' }" />
    </p-popover>
  </div>

  <span class="rte-toolbar__sep" aria-hidden="true"></span>

  <!-- Alinhamento -->
  <div class="rte-toolbar__group">
    @for (alignment of alignments; track alignment.icon) {
      <button
        type="button"
        class="rte-btn"
        [class.rte-btn--active]="isActive('align', alignment.value)"
        [attr.aria-pressed]="isActive('align', alignment.value)"
        [pTooltip]="alignment.tooltip"
        tooltipPosition="bottom"
        [attr.aria-label]="alignment.tooltip"
        (mousedown)="$event.preventDefault()"
        (click)="emitFormat('align', alignment.value)">
        <i [class]="alignment.icon"></i>
      </button>
    }
  </div>

  <span class="rte-toolbar__sep" aria-hidden="true"></span>

  <!-- Listas, recuo e citação -->
  <div class="rte-toolbar__group">
    <button
      type="button"
      class="rte-btn"
      [class.rte-btn--active]="isActive('list', 'ordered')"
      [attr.aria-pressed]="isActive('list', 'ordered')"
      pTooltip="Lista numerada"
      tooltipPosition="bottom"
      aria-label="Lista numerada"
      (mousedown)="$event.preventDefault()"
      (click)="toggleList('ordered')">
      <svg class="rte-btn__svg" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M9 6h12v2H9V6Zm0 5h12v2H9v-2Zm0 5h12v2H9v-2ZM3.5 5H5v4H4V6h-.5V5Zm-.4 6.6c.2-.4.7-.6 1.2-.6.7 0 1.2.4 1.2 1 0 .4-.2.7-.6 1L4.3 14h1.3v1H3v-.8l1.4-1.3c.2-.2.3-.3.3-.5 0-.2-.1-.3-.3-.3-.2 0-.3.1-.4.3l-.9-.8ZM3 17h2.6v.8l-.8.7c.5.1.9.5.9 1 0 .7-.6 1.3-1.4 1.3-.6 0-1.1-.3-1.3-.8l.8-.5c.1.2.3.3.5.3s.4-.1.4-.3c0-.2-.2-.3-.5-.3H4v-.8l.5-.4H3V17Z" />
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.rte-btn--active]="isActive('list', 'bullet')"
      [attr.aria-pressed]="isActive('list', 'bullet')"
      pTooltip="Lista com marcadores"
      tooltipPosition="bottom"
      aria-label="Lista com marcadores"
      (mousedown)="$event.preventDefault()"
      (click)="toggleList('bullet')">
      <i class="pi pi-list"></i>
    </button>
    <button
      type="button"
      class="rte-btn"
      pTooltip="Diminuir recuo"
      tooltipPosition="bottom"
      aria-label="Diminuir recuo"
      (mousedown)="$event.preventDefault()"
      (click)="emit({ type: 'indent', step: -1 })">
      <svg class="rte-btn__svg" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 4h18v2H3V4Zm8 5h10v2H11V9Zm0 4h10v2H11v-2ZM3 18h18v2H3v-2Zm4-9v6l-4-3 4-3Z" />
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      pTooltip="Aumentar recuo"
      tooltipPosition="bottom"
      aria-label="Aumentar recuo"
      (mousedown)="$event.preventDefault()"
      (click)="emit({ type: 'indent', step: 1 })">
      <svg class="rte-btn__svg" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 4h18v2H3V4Zm8 5h10v2H11V9Zm0 4h10v2H11v-2ZM3 18h18v2H3v-2Zm0-9 4 3-4 3V9Z" />
      </svg>
    </button>
    <button
      type="button"
      class="rte-btn"
      [class.rte-btn--active]="isActive('blockquote')"
      [attr.aria-pressed]="isActive('blockquote')"
      pTooltip="Citação"
      tooltipPosition="bottom"
      aria-label="Citação"
      (mousedown)="$event.preventDefault()"
      (click)="toggle('blockquote')">
      <svg class="rte-btn__svg" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M7.2 6C4.9 7.1 3.5 9.2 3.5 12v6h6v-6H6.2c0-1.6.8-2.8 2.2-3.5L7.2 6Zm10 0c-2.3 1.1-3.7 3.2-3.7 6v6h6v-6h-3.3c0-1.6.8-2.8 2.2-3.5L17.2 6Z" />
      </svg>
    </button>
  </div>

  <span class="rte-toolbar__sep" aria-hidden="true"></span>

  <!-- Link, tabela e limpar -->
  <div class="rte-toolbar__group">
    <button
      type="button"
      class="rte-btn"
      [class.rte-btn--active]="isActive('link')"
      pTooltip="Inserir link"
      tooltipPosition="bottom"
      aria-label="Inserir link"
      aria-haspopup="dialog"
      (mousedown)="$event.preventDefault()"
      (click)="openLinkPopover($event)">
      <i class="pi pi-link"></i>
    </button>
    <p-popover #linkPopover appendTo="body" styleClass="rte-popover">
      <form class="rte-link" (ngSubmit)="applyLink()">
        <app-input
          label="Endereço do link"
          placeholder="https://site.com.br ou e-mail"
          name="rteLinkUrl"
          [(ngModel)]="linkUrl" />
        @if (linkError()) {
          <small class="rte-link__error">{{ linkError() }}</small>
        }
        <div class="rte-link__actions">
          @if (isActive('link')) {
            <app-button
              label="Remover link"
              theme="white"
              size="small"
              type="button"
              (sendButtonClick)="removeLink()" />
          }
          <app-button label="Aplicar" size="small" type="submit" />
        </div>
      </form>
    </p-popover>

    <button
      type="button"
      class="rte-btn rte-btn--select"
      [class.rte-btn--active]="isInTable()"
      pTooltip="Tabela: inserir, linhas e colunas"
      tooltipPosition="bottom"
      aria-haspopup="menu"
      (mousedown)="$event.preventDefault()"
      (click)="openTableMenu($event)">
      <i class="pi pi-table"></i>
      <i class="pi pi-chevron-down rte-btn__caret"></i>
    </button>
    <p-menu #tableMenu [model]="tableItems()" [popup]="true" appendTo="body" />

    <button
      type="button"
      class="rte-btn"
      pTooltip="Limpar formatação"
      tooltipPosition="bottom"
      aria-label="Limpar formatação"
      (mousedown)="$event.preventDefault()"
      (click)="emit({ type: 'clearFormatting' })">
      <i class="pi pi-eraser"></i>
    </button>
  </div>

  @if (variables().length) {
    <span class="rte-toolbar__sep" aria-hidden="true"></span>

    <div class="rte-toolbar__group">
      <button
        type="button"
        class="rte-btn rte-btn--select rte-btn--variable"
        pTooltip="Inserir um dado que muda por parceiro, como a razão social ou o CNPJ"
        tooltipPosition="bottom"
        aria-haspopup="menu"
        (mousedown)="$event.preventDefault()"
        (click)="variableMenu.toggle($event)">
        <i class="pi pi-tag"></i>
        <span class="rte-btn__text">Variável</span>
        <i class="pi pi-chevron-down rte-btn__caret"></i>
      </button>
      <p-menu
        #variableMenu
        [model]="variableItems()"
        [popup]="true"
        appendTo="body"
        styleClass="rte-variable-menu" />
    </div>
  }

  <div class="rte-toolbar__spacer"></div>

  <div class="rte-toolbar__group">
    <button
      type="button"
      class="rte-btn"
      [class.rte-btn--active]="fullscreen()"
      [pTooltip]="fullscreen() ? 'Sair da tela cheia (Esc)' : 'Tela cheia'"
      tooltipPosition="bottom"
      [attr.aria-label]="fullscreen() ? 'Sair da tela cheia' : 'Tela cheia'"
      (mousedown)="$event.preventDefault()"
      (click)="toggleFullscreen.emit()">
      <i [class]="fullscreen() ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"></i>
    </button>
  </div>
</div>

<!-- Grade de cores compartilhada pelos dois popovers (texto e destaque) -->
<ng-template #paletteTemplate let-name="name" let-resetLabel="resetLabel">
  <div class="rte-palette">
    <button type="button" class="rte-palette__reset" (click)="pickColor(name, false)">
      <i class="pi pi-ban"></i>
      {{ resetLabel }}
    </button>
    <div class="rte-palette__grid">
      @for (color of palette; track color) {
        <button
          type="button"
          class="rte-palette__swatch"
          [style.background]="color"
          [attr.aria-label]="color"
          [pTooltip]="color"
          tooltipPosition="top"
          (click)="pickColor(name, color)"></button>
      }
    </div>
  </div>
</ng-template>
